export default "68f75160873691ba.svg"